// Delete this when the tide API follows the standards
// This list was generated via `allCapabilities.map(a => a.id).filter(a => a.includes('tide'))`
const badCapabilities = [
    'ssh_notide',
    'tide_elevation_constituent_amplitude',
    'tide_elevation_constituent_phase',
    'tide_elevation_lat',
    'tide_elevation_msl',
    'tide_times_lat',
    'tide_times_msl',
];
// This function returns a "databilityIndex".
// Consider two different databilities with identical query criteria.
// This index allows us to "relate" these databilities by their query criteria.
// They can relate by sharing a databilityIndex and using that to access data.
export const getDatabilityIndex = (datability) => {
    if (badCapabilities.includes(datability.capabilityId ?? ''))
        return [
            datability.datasetId,
            JSON.stringify(datability.space),
            datability.interpolationInterval,
            datability.timeRange,
            datability.data_structure,
            datability.capabilityId, // Malformed services cannot be consolidated
        ].join('₿');
    return [datability.datasetId, JSON.stringify(datability.space), datability.interpolationInterval, datability.timeRange, datability.data_structure].join('₿');
};
